export default __webpack_public_path__ + "assets/2b8d3e8d66ec3ef347c033dd68776589.png";